import {
  SET_SNACKBAR,
  CLOSE_SNACKBAR,
  SET_WINDOW_SIZES,
  SET_PREV_PAGE,
  SET_SIDEBAR_STATE,
  CLOSE_COOKIES_SNACKBAR
} from './types'
import Config from 'config'

const {
  md,
  xm,
  lg,
  fullHd
} = Config.layout

const initialState = {
  cookiesSnack: localStorage.getItem('cookiesSnack'),
  snackbarMessage: null,
  snackbarType: 'success',
  isMobile: window.innerWidth < md,
  isDesktop: window.innerWidth >= xm,
  isLargeDesktop: window.innerWidth > lg,
  prevPage: null,
  isOpenSidebar: window.innerWidth > lg
}

const commonReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SNACKBAR:
      return {
        ...state,
        snackbarMessage: action.payload.message,
        snackbarType: action.payload.type
      }
    case CLOSE_SNACKBAR:
      return {
        ...state,
        snackbarMessage: null
      }
    case SET_WINDOW_SIZES:
      return {
        ...state,
        isMobile: window.innerWidth < md,
        isDesktop: window.innerWidth >= xm,
        isLargeDesktop: window.innerWidth > lg,
        isFullHd: window.innerWidth >= fullHd,
      }
    case SET_PREV_PAGE:
      return {
        ...state,
        prevPage: action.payload.prevPage
      }
    case SET_SIDEBAR_STATE:
      return {
        ...state,
        isOpenSidebar: action.payload.isOpenSidebar
      }
    case CLOSE_COOKIES_SNACKBAR:
      return {
        ...state,
        cookiesSnack: true
      }
    default:
      return state
  }
}

export default commonReducer
